import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import Component from "@reactions/component";
import { Pane, Dialog, SideSheet } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Form, Button, Table } from 'react-bootstrap';

import Edit from '@material-ui/icons/Edit';
import 'react-toastify/dist/ReactToastify.css';
import CategoryIcon from '@material-ui/icons/Category';
import Autorenew from '@material-ui/icons/Autorenew';
import HistoryToggleOff from '@material-ui/icons/History';
import MultiSelect from "@kenshooui/react-multi-select";
import SpeakerNotes from '@material-ui/icons/SpeakerNotes';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MoneyOff from '@material-ui/icons/MoneyOff';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Login from '../common/login';
import * as moment from "moment-timezone";

const cookies = new Cookies();

// =============================================
// التصميم الجديد - Clean Modern Arabic UI
// =============================================
const appStyles = `
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@300;400;500;600;700&display=swap');

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'IBM Plex Sans Arabic', sans-serif;
    background: #f0f2f5;
    direction: rtl;
    min-height: 100vh;
}

/* ================================ */
/* App Container */
/* ================================ */
.app-container {
    min-height: 100vh;
    background: #f0f2f5;
}

/* ================================ */
/* Header */
/* ================================ */
.app-header {
    background: #fff;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e6eb;
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 15px;
}

.btn-back-header {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f0f2f5;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #65676b;
    transition: 0.2s;
}

.btn-back-header:hover {
    background: #e4e6eb;
    color: #1877f2;
}

.header-title {
    font-size: 22px;
    font-weight: 700;
    color: #1c1e21;
    margin: 0;
}

.header-stats {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stat-chip {
    background: #e7f3ff;
    color: #1877f2;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
}

/* ================================ */
/* Search Section */
/* ================================ */
.search-section {
    padding: 25px 30px;
    background: #fff;
    border-bottom: 1px solid #e4e6eb;
}

.search-wrapper {
    max-width: 600px;
    margin: 0 auto;
    position: relative;
}

.search-input-container {
    display: flex;
    background: #f0f2f5;
    border-radius: 25px;
    overflow: hidden;
    border: 2px solid transparent;
    transition: 0.2s;
}

.search-input-container:focus-within {
    border-color: #1877f2;
    background: #fff;
}

.search-input {
    flex: 1;
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 15px;
    font-family: inherit;
    color: #1c1e21;
    direction: rtl;
}

.search-input::placeholder {
    color: #65676b;
}

.search-input:focus {
    outline: none;
}

.search-btn {
    padding: 14px 28px;
    background: #1877f2;
    color: #fff;
    border: none;
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: 0.2s;
}

.search-btn:hover {
    background: #166fe5;
}

/* ================================ */
/* Main Content */
/* ================================ */
.main-content {
    padding: 25px 30px;
    width: 100%;
    max-width: 100%;
    margin: 0;
    overflow: visible;
}

/* ================================ */
/* Table Card */
/* ================================ */
.table-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.table-card-header {
    padding: 20px 25px;
    border-bottom: 1px solid #e4e6eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.table-card-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c1e21;
    margin: 0;
}

.table-card-count {
    background: #1877f2;
    color: #fff;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
}

/* DataTable Styling */
.MuiPaper-root {
    box-shadow: none !important;
    width: 100% !important;
    overflow: hidden !important;
}

.MuiTableContainer-root {
    width: 100% !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    /* إخفاء السكرول بار مع السماح بالسكرول */
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}

.MuiTableContainer-root::-webkit-scrollbar {
    display: none !important;
}

.MuiTable-root {
    width: max-content !important;
    min-width: 100% !important;
    direction: rtl !important;
    table-layout: auto !important;
}

.MuiTableHead-root .MuiTableCell-head {
    background: #f8f9fa !important;
    color: #1c1e21 !important;
    font-weight: 700 !important;
    font-size: 13px !important;
    padding: 12px 10px !important;
    border-bottom: 2px solid #e4e6eb !important;
    text-align: center !important;
    white-space: nowrap !important;
    font-family: 'IBM Plex Sans Arabic', sans-serif !important;
    direction: rtl !important;
}

.MuiTableBody-root .MuiTableRow-root {
    transition: 0.15s;
    direction: rtl !important;
}

.MuiTableBody-root .MuiTableRow-root:hover {
    background: #f8f9fa !important;
}

.MuiTableBody-root .MuiTableCell-root {
    padding: 10px !important;
    font-size: 13px !important;
    color: #1c1e21 !important;
    border-bottom: 1px solid #f0f2f5 !important;
    text-align: center !important;
    font-family: 'IBM Plex Sans Arabic', sans-serif !important;
    direction: rtl !important;
    white-space: nowrap !important;
}

/* إصلاح اتجاه الجدول بالكامل */
.MuiTableRow-root {
    direction: rtl !important;
}

.MuiTableCell-root {
    text-align: center !important;
    direction: rtl !important;
}

/* إخفاء الـ Toolbar الفارغ */
.MuiToolbar-root.MuiToolbar-regular {
    display: none !important;
}

/* إصلاح الـ Pagination */
.MuiTablePagination-root {
    direction: rtl !important;
    overflow: hidden !important;
}

.MuiTablePagination-toolbar {
    direction: rtl !important;
    padding: 10px 16px !important;
    min-height: 52px !important;
    display: flex !important;
}

.MuiTablePagination-spacer {
    display: none !important;
}

.MuiTablePagination-selectRoot {
    direction: rtl !important;
    margin-right: 8px !important;
    margin-left: 24px !important;
}

.MuiTablePagination-actions {
    direction: ltr !important;
    margin-right: auto !important;
    margin-left: 0 !important;
}

/* إصلاح عرض الجدول */
.table-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    width: 100%;
}

.table-card > div {
    width: 100% !important;
}

/* التأكد من أن الجدول يأخذ العرض الكامل */
[class*="MuiPaper"] {
    width: 100% !important;
}

[class*="MaterialDatatable"] {
    width: 100% !important;
}

/* إخفاء أي toolbar */
.MuiToolbar-root {
    display: none !important;
}

/* إظهار فقط pagination toolbar */
.MuiTablePagination-toolbar {
    display: flex !important;
}

/* main content */
.main-content {
    overflow: visible !important;
}

/* مؤشر للسحب الأفقي */
.table-card::after {
    content: '← اسحب لرؤية المزيد →';
    display: none;
    text-align: center;
    padding: 8px;
    font-size: 12px;
    color: #65676b;
    background: #f8f9fa;
    border-top: 1px solid #e4e6eb;
}

@media (max-width: 1200px) {
    .table-card::after {
        display: block;
    }
}

/* ================================ */
/* Action Buttons */
/* ================================ */
.action-btn {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 3px;
    transition: 0.2s;
}

.action-btn:hover {
    transform: scale(1.1);
}

.action-btn.blue {
    background: #e7f3ff;
    color: #1877f2;
}

.action-btn.blue:hover {
    background: #1877f2;
    color: #fff;
}

.action-btn.green {
    background: #e6f7e9;
    color: #31a24c;
}

.action-btn.green:hover {
    background: #31a24c;
    color: #fff;
}

.action-btn.red {
    background: #ffebe9;
    color: #e41e3f;
}

.action-btn.red:hover {
    background: #e41e3f;
    color: #fff;
}

.action-btn.orange {
    background: #fff4e6;
    color: #f5a623;
}

.action-btn.orange:hover {
    background: #f5a623;
    color: #fff;
}

.action-btn.purple {
    background: #f3e8ff;
    color: #8b5cf6;
}

.action-btn.purple:hover {
    background: #8b5cf6;
    color: #fff;
}

/* ================================ */
/* Status Badges */
/* ================================ */
.status-badge {
    display: inline-block;
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
}

.status-pending { background: #fff4e6; color: #e8590c; }
.status-processing { background: #e7f3ff; color: #1877f2; }
.status-success { background: #e6f7e9; color: #31a24c; }
.status-cancelled { background: #ffebe9; color: #e41e3f; }
.status-rejected { background: #f3e8ff; color: #8b5cf6; }
.status-disabled { background: #f0f2f5; color: #65676b; font-size: 11px; }

/* ================================ */
/* Empty State */
/* ================================ */
.empty-state {
    text-align: center;
    padding: 80px 30px;
    background: #fff;
    border-radius: 12px;
}

.empty-state-icon {
    font-size: 64px;
    margin-bottom: 20px;
}

.empty-state-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c1e21;
    margin-bottom: 10px;
}

.empty-state-text {
    font-size: 15px;
    color: #65676b;
    margin-bottom: 25px;
}

.btn-primary-custom {
    background: #1877f2;
    color: #fff;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: 0.2s;
}

.btn-primary-custom:hover {
    background: #166fe5;
}

.btn-secondary-custom {
    background: #e4e6eb;
    color: #1c1e21;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: 0.2s;
}

.btn-secondary-custom:hover {
    background: #d8dadf;
}

.action-btn.orange {
    background: #fff4e6;
    color: #f5a623;
}

.action-btn.orange:hover {
    background: #f5a623;
    color: #fff;
}

/* ================================ */
/* Mobile Cards View */
/* ================================ */
.mobile-cards-container {
    display: none;
}

.order-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.order-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f2f5;
    margin-bottom: 12px;
}

.order-card-id {
    font-size: 18px;
    font-weight: 700;
    color: #1877f2;
}

.order-card-status {
    font-size: 12px;
}

.order-card-body {
    display: grid;
    gap: 10px;
}

.order-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}

.order-card-label {
    color: #65676b;
    font-weight: 500;
}

.order-card-value {
    color: #1c1e21;
    font-weight: 600;
}

.order-card-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #f0f2f5;
    margin-top: 12px;
    flex-wrap: wrap;
}

/* Desktop Table View */
.desktop-table {
    display: block;
}

@media (max-width: 900px) {
    .desktop-table {
        display: none !important;
    }
    
    .mobile-cards-container {
        display: block;
    }
    
    .table-card-header {
        border-radius: 12px;
        margin-bottom: 15px;
    }
}

/* ================================ */
/* Loading Overlay */
/* ================================ */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.95);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
}

.loading-overlay.active {
    opacity: 1;
    visibility: visible;
}

.loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #e4e6eb;
    border-top-color: #1877f2;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.loading-text {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    color: #1c1e21;
}

.loading-subtext {
    margin-top: 8px;
    font-size: 14px;
    color: #65676b;
}

/* ================================ */
/* Dialog Styling */
/* ================================ */
.dialog-content {
    padding: 20px;
    text-align: center;
    direction: rtl;
}

.dialog-icon {
    font-size: 48px;
    margin-bottom: 15px;
}

.dialog-message {
    font-size: 16px;
    color: #1c1e21;
    margin-bottom: 10px;
}

.dialog-submessage {
    font-size: 14px;
    color: #65676b;
}

/* ================================ */
/* Form Elements */
/* ================================ */
.form-group-custom {
    margin-bottom: 20px;
    text-align: right;
}

.form-label-custom {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1c1e21;
    margin-bottom: 8px;
}

.form-input-custom {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #e4e6eb;
    border-radius: 8px;
    font-size: 15px;
    font-family: inherit;
    color: #1c1e21;
    transition: 0.2s;
    direction: rtl;
}

.form-input-custom:focus {
    outline: none;
    border-color: #1877f2;
    box-shadow: 0 0 0 3px rgba(24,119,242,0.1);
}

/* ================================ */
/* SideSheet */
/* ================================ */
.sidesheet-header {
    background: #1877f2;
    padding: 25px;
    color: #fff;
}

.sidesheet-title {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
}

.sidesheet-body {
    padding: 25px;
    background: #f8f9fa;
    min-height: calc(100vh - 80px);
}

.sidesheet-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.sidesheet-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #1c1e21;
    margin-bottom: 15px;
}

/* ================================ */
/* Custom Table */
/* ================================ */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.custom-table th {
    background: #f8f9fa;
    padding: 12px 15px;
    text-align: right;
    font-weight: 600;
    color: #1c1e21;
    border-bottom: 2px solid #e4e6eb;
}

.custom-table td {
    padding: 12px 15px;
    text-align: right;
    border-bottom: 1px solid #f0f2f5;
    color: #1c1e21;
}

.custom-table tr:hover td {
    background: #f8f9fa;
}

/* ================================ */
/* Login Page */
/* ================================ */
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2f5;
    padding: 20px;
}

.login-card {
    background: #fff;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.login-icon {
    font-size: 48px;
    margin-bottom: 20px;
}

.login-title {
    font-size: 22px;
    font-weight: 700;
    color: #1c1e21;
    margin-bottom: 25px;
}

/* ================================ */
/* Responsive */
/* ================================ */
@media (max-width: 768px) {
    .app-header {
        padding: 15px 20px;
        flex-wrap: wrap;
        gap: 15px;
    }
    
    .header-title {
        font-size: 18px;
    }
    
    .header-stats {
        display: none;
    }
    
    .search-section {
        padding: 20px;
    }
    
    .search-input-container {
        flex-direction: column;
        border-radius: 12px;
    }
    
    .search-input {
        padding: 14px 16px;
        border-bottom: 1px solid #e4e6eb;
    }
    
    .search-btn {
        padding: 14px;
        border-radius: 0 0 10px 10px;
    }
    
    .main-content {
        padding: 15px;
    }
    
    .table-card-header {
        padding: 15px 20px;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
    
    /* إصلاح الجدول في الموبايل - تحويله لكروت */
    .table-card {
        background: transparent;
        box-shadow: none;
    }
    
    .MuiPaper-root {
        background: transparent !important;
    }
    
    .MuiTable-root {
        display: block !important;
    }
    
    .MuiTableHead-root {
        display: none !important;
    }
    
    .MuiTableBody-root {
        display: block !important;
    }
    
    .MuiTableBody-root .MuiTableRow-root {
        display: block !important;
        background: #fff !important;
        margin-bottom: 15px !important;
        border-radius: 12px !important;
        padding: 15px !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    }
    
    .MuiTableBody-root .MuiTableCell-root {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        padding: 8px 0 !important;
        border-bottom: 1px solid #f0f2f5 !important;
        text-align: right !important;
        font-size: 14px !important;
    }
    
    .MuiTableBody-root .MuiTableCell-root:last-child {
        border-bottom: none !important;
    }
    
    .MuiTableBody-root .MuiTableCell-root::before {
        content: attr(data-label);
        font-weight: 700;
        color: #65676b;
        font-size: 12px;
    }
    
    /* إخفاء pagination في الموبايل أو تبسيطه */
    .MuiTablePagination-toolbar {
        flex-wrap: wrap;
        justify-content: center;
        padding: 10px !important;
    }
    
    .action-btn {
        width: 36px;
        height: 36px;
    }
}

/* ================================ */
/* Toast */
/* ================================ */
.Toastify__toast {
    font-family: 'IBM Plex Sans Arabic', sans-serif !important;
    border-radius: 10px !important;
}
`;

// =============================================
// أعمدة الجدول - الترتيب من اليمين لليسار
// =============================================
const columns = [
    { field: "id", name: "#", options: { filter: false } },
    { field: "user_name", name: "المستخدم", options: { filter: false, search: false } },
    { field: "phone", name: "الهاتف", options: { filter: false, search: false } },
    { field: "government", name: "الموقع", options: { filter: false, sort: false, search: false } },
    { field: "price", name: "السعر", options: { filter: true, sort: false, search: false } },
    { field: "status", name: "الحالة", options: { filter: true, sort: false, search: false } },
    { field: "createdAt", name: "التاريخ", options: { filter: true, sort: false, search: false } },
    { field: "updatedAt", name: "التحديث", options: { filter: true, sort: false, search: false } },
    { field: "log", name: "السجل", options: { filter: false, sort: false } },
    { field: "items", name: "المواد", options: { filter: false, sort: false } },
    { field: "notes", name: "ملاحظات", options: { filter: false, sort: false, search: false } },
    { field: "print_name", name: "صاحب القائمة", options: { filter: false, sort: false } },
    { field: "print_id", name: "القائمة", options: { filter: false, sort: false } },
    { field: "edit_order", name: "تعديل", options: { filter: false, sort: false } },
    { field: "watting", name: "إعادة", options: { filter: false, sort: false } },
    { field: "edit", name: "السعر", options: { filter: false, sort: false, search: false } },
    { field: "delete", name: "حذف", options: { filter: false, sort: false, search: false } },
];

const options = {
    selectableRows: false,
    responsive: 'scroll',
    rowCursorHand: false,
    sort: false,
    print: false,
    filter: false,
    search: false,
    download: false,
    textLabels: {
        body: { noMatch: "لا توجد بيانات", toolTip: "فرز" },
        pagination: { next: "التالي", previous: "السابق", rowsPerPage: "الصفوف:", displayRows: "من" },
        toolbar: { search: "بحث", downloadCsv: "تحميل", print: "طباعة", viewColumns: "الأعمدة", filterTable: "فلتر" },
        filter: { all: "الكل", title: "فلتر", reset: "إعادة" },
        viewColumns: { title: "الأعمدة", titleAria: "إظهار/إخفاء" },
    },
};

// =============================================
// المكون الرئيسي
// =============================================
class fromOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Category: [],
            ordersRaw: [],
            spin: false,
            priceItem: '',
            items: [],
            selectedItems: [],
            loadingAction: false,
            loadingMessage: '',
            loadingSubtext: '',
        };
    }

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: { root: { textAlign: 'right' } },
            MuiTableCell: { root: { textAlign: 'right' } },
        }
    });

    showLoading = (message, subtext = 'يرجى الانتظار...') => {
        this.setState({ loadingAction: true, loadingMessage: message, loadingSubtext: subtext });
    };

    hideLoading = () => {
        this.setState({ loadingAction: false, loadingMessage: '', loadingSubtext: '' });
    };

    getStatusBadge = (status) => {
        const statusMap = {
            0: { class: 'status-pending', text: 'قيد الطباعة' },
            1: { class: 'status-processing', text: 'قيد المعالجة' },
            2: { class: 'status-cancelled', text: 'ملغي' },
            3: { class: 'status-success', text: 'ناجح' },
            4: { class: 'status-rejected', text: 'مرفوض' },
            [-1]: { class: 'status-pending', text: 'لا يرد' },
            [-2]: { class: 'status-pending', text: 'غير مؤكد' },
            [-3]: { class: 'status-rejected', text: 'غير موجود' },
            5: { class: 'status-disabled', text: 'معلق' },
        };
        const s = statusMap[status] || { class: 'status-disabled', text: 'غير محدد' };
        return <span className={`status-badge ${s.class}`}>{s.text}</span>;
    };

    componentDidMount() {
        const header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        axios.get(host + `dashbord/items/get/all`, { headers: header })
            .then((response) => {
                const items_all = response.data.items.map(item => ({
                    label: item.name,
                    id: item.id,
                    count: item.count
                }));
                this.setState({ items: items_all });
            })
            .catch(error => console.log(error));
    }

    restore = (id) => {
        this.showLoading('إلغاء وإعادة الطلب', 'جاري المعالجة...');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        axios.delete(host + `users/can_re/${id}`, { headers: header })
            .then(() => {
                this.hideLoading();
                toast.success('تم بنجاح');
                this.Search(id);
            })
            .catch(() => {
                this.hideLoading();
                toast.error('حدث خطأ');
            });
    };

    edit = (obj, id) => {
        const price = document.getElementById('Editprice')?.value;
        const notes = document.getElementById('Editnotes')?.value;

        if (!price) {
            toast.warn('أدخل السعر');
            return;
        }

        this.showLoading('تعديل الطلب', 'جاري الحفظ...');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        const formData = new FormData();
        formData.append("price", price);
        formData.append("notes", notes);
        formData.append("items", JSON.stringify(obj));

        axios({ url: host + `dashbord/order/edit/${id}`, method: "POST", data: formData, headers: header })
            .then(() => {
                this.hideLoading();
                this.Search();
                toast.success('تم التعديل');
            })
            .catch(() => {
                this.hideLoading();
                toast.error('حدث خطأ');
            });
    };

    Search = (search) => {
        const { items } = this.state;
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        // 🔒 نداء بلا وسيط (بعد تعديل/حذف) كان يرسل id='' ⟵ الخادم يسحب
        //     الجدول كاملاً بكل العلاقات ⟵ OOM. نرجع لآخر بحث، وإلا 'ss' (صفر نتائج).
        const q = String(search || this.state.lastSearch || 'ss').trim() || 'ss';
        if (q !== 'ss') this.setState({ lastSearch: q });

        this.setState({ spin: true });

        axios.get(host + `dashbord/form/orders/all?id=${q}`, { headers: header })
            .then(res => {
                const arr = res.data.data.orders.map(order => {
                    // Status Badge
                    const getStatus = (status) => {
                        const statusMap = {
                            0: { class: 'status-pending', text: 'قيد الطباعة' },
                            1: { class: 'status-processing', text: 'قيد المعالجة' },
                            2: { class: 'status-cancelled', text: 'ملغي' },
                            3: { class: 'status-success', text: 'ناجح' },
                            4: { class: 'status-rejected', text: 'مرفوض' },
                            [-1]: { class: 'status-pending', text: 'لا يرد' },
                            [-2]: { class: 'status-pending', text: 'غير مؤكد' },
                            [-3]: { class: 'status-rejected', text: 'غير موجود' },
                            5: { class: 'status-disabled', text: 'معلق' },
                        };
                        const s = statusMap[status] || { class: 'status-disabled', text: 'غير محدد' };
                        return <span className={`status-badge ${s.class}`}>{s.text}</span>;
                    };

                    const obj = {
                        id: order.id,
                        user_name: order.user.name,
                        phone: order.phone,
                        government: `${order.government} / ${order.city}`,
                        price: <strong style={{ color: '#31a24c' }}>{order.price?.toLocaleString()}</strong>,
                        print_id: <Link to={`dayle_orders?id=${order.print_id}`} style={{ color: '#1877f2', fontWeight: '600' }}>{order.print_id}</Link>,
                        print_name: order.print_name,
                        status: getStatus(order.status),
                        updatedAt: moment(order.updatedAt).tz('Asia/baghdad').format('MM/DD'),
                        createdAt: moment(order.createdAt).tz('Asia/baghdad').format('MM/DD'),

                        // ملاحظات
                        notes: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog isShown={state.isShown} title="ملاحظات" hasFooter={false} onCloseComplete={() => setState({ isShown: false })}>
                                        <div className="dialog-content">
                                            <p className="dialog-message">{order.notes || 'لا توجد ملاحظات'}</p>
                                        </div>
                                    </Dialog>
                                    <button className="action-btn orange" onClick={() => setState({ isShown: true })}>
                                        <SpeakerNotes style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,

                        // المواد
                        items: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog isShown={state.isShown} title="مواد الطلب" hasFooter={false} onCloseComplete={() => setState({ isShown: false })}>
                                        <table className="custom-table">
                                            <thead><tr><th>العدد</th><th>المنتج</th></tr></thead>
                                            <tbody>
                                                {order.items.map((item, i) => (
                                                    <tr key={i}><td><strong>{item.count}</strong></td><td>{item.name}</td></tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Dialog>
                                    <button className="action-btn blue" onClick={() => setState({ isShown: true })}>
                                        <CategoryIcon style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,

                        // السجل
                        log: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog isShown={state.isShown} title="سجل الطلب" hasFooter={false} onCloseComplete={() => setState({ isShown: false })} width={550}>
                                        <table className="custom-table">
                                            <thead><tr><th>المستخدم</th><th>الحالة</th><th>التاريخ</th></tr></thead>
                                            <tbody>
                                                {order.log?.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.user?.name}</td>
                                                        <td>{item.status}</td>
                                                        <td>{moment(item.createdAt).tz('Asia/baghdad').format('MM/DD hh:mm A')}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Dialog>
                                    <button className="action-btn purple" onClick={() => setState({ isShown: true })}>
                                        <HistoryToggleOff style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,

                        // إلغاء وإعادة
                        watting: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog
                                        isShown={state.isShown}
                                        title="إلغاء وإعادة"
                                        intent="success"
                                        onCloseComplete={() => setState({ isShown: false })}
                                        confirmLabel="تأكيد"
                                        cancelLabel="إلغاء"
                                        onConfirm={() => { setState({ isShown: false }); this.restore(order.id); }}
                                    >
                                        <div className="dialog-content">
                                            <div className="dialog-icon">🔄</div>
                                            <p className="dialog-message">إلغاء وإعادة الطلب #{order.id}؟</p>
                                        </div>
                                    </Dialog>
                                    <button className="action-btn green" onClick={() => setState({ isShown: true })}>
                                        <Autorenew style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,

                        // تعديل الطلب
                        edit_order: <Component initialState={{ isShown: false, selectedItems: [] }}>
                            {({ state, setState }) => (
                                <React.Fragment>
                                    <SideSheet isShown={state.isShown} position="left" onCloseComplete={() => setState({ isShown: false })} width={420}>
                                        <div className="sidesheet-header">
                                            <h3 className="sidesheet-title">تعديل الطلب #{order.id}</h3>
                                        </div>
                                        <div className="sidesheet-body">
                                            <div className="sidesheet-card">
                                                <div className="sidesheet-card-title">اختر المنتجات</div>
                                                <MultiSelect
                                                    items={items}
                                                    selectedItems={state.selectedItems}
                                                    onChange={(e) => setState({ selectedItems: e })}
                                                    showSelectedItems={false}
                                                    showSelectAll={false}
                                                />
                                                {state.selectedItems.length > 0 && (
                                                    <table className="custom-table" style={{ marginTop: 15 }}>
                                                        <thead><tr><th>العدد</th><th>المنتج</th></tr></thead>
                                                        <tbody>
                                                            {state.selectedItems.map((item, i) => (
                                                                <tr key={i}>
                                                                    <td><input type="number" className="form-input-custom" id={item.id} defaultValue={1} min="1" style={{ width: 70 }} /></td>
                                                                    <td>{item.label}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                            <div className="form-group-custom">
                                                <label className="form-label-custom">السعر مع التوصيل</label>
                                                <input type="number" className="form-input-custom" id="Editprice" placeholder="السعر" />
                                            </div>
                                            <div className="form-group-custom">
                                                <label className="form-label-custom">ملاحظات</label>
                                                <textarea className="form-input-custom" id="Editnotes" placeholder="ملاحظات..." rows={3} style={{ resize: 'none' }} />
                                            </div>
                                            <button
                                                className="btn-primary-custom"
                                                style={{ width: '100%' }}
                                                onClick={() => {
                                                    const arr = state.selectedItems.map(item => ({
                                                        id: item.id,
                                                        name: item.label,
                                                        count: Number(document.getElementById(item.id)?.value || 1)
                                                    }));
                                                    this.edit(arr, order.id);
                                                    setState({ isShown: false });
                                                }}
                                            >
                                                حفظ التعديلات
                                            </button>
                                        </div>
                                    </SideSheet>
                                    <button className="action-btn blue" onClick={() => setState({ isShown: true })}>
                                        <Edit style={{ fontSize: 18 }} />
                                    </button>
                                </React.Fragment>
                            )}
                        </Component>,

                        // تعديل السعر
                        edit: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog
                                        isShown={state.isShown}
                                        title="تعديل السعر"
                                        onCloseComplete={() => setState({ isShown: false })}
                                        confirmLabel="تعديل"
                                        cancelLabel="إلغاء"
                                        onConfirm={() => { this.EditItem(order.id); setState({ isShown: false }); }}
                                    >
                                        <div style={{ padding: 15 }}>
                                            <div className="form-group-custom">
                                                <label className="form-label-custom">السعر الجديد</label>
                                                <input
                                                    type="number"
                                                    className="form-input-custom"
                                                    placeholder="أدخل السعر"
                                                    onChange={(e) => this.setState({ priceItem: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </Dialog>
                                    <button className="action-btn green" onClick={() => setState({ isShown: true })}>
                                        <MoneyOff style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,

                        // حذف
                        delete: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog
                                        isShown={state.isShown}
                                        title="حذف الطلب"
                                        intent="danger"
                                        onCloseComplete={() => setState({ isShown: false })}
                                        confirmLabel="حذف"
                                        cancelLabel="إلغاء"
                                        onConfirm={() => { setState({ isShown: false }); this.DeleteCate(order.id); }}
                                    >
                                        <div className="dialog-content">
                                            <div className="dialog-icon">⚠️</div>
                                            <p className="dialog-message">حذف الطلب #{order.id}؟</p>
                                            <p className="dialog-submessage">لا يمكن التراجع عن هذا الإجراء</p>
                                        </div>
                                    </Dialog>
                                    <button className="action-btn red" onClick={() => setState({ isShown: true })}>
                                        <DeleteForeverIcon style={{ fontSize: 18 }} />
                                    </button>
                                </Pane>
                            )}
                        </Component>,
                    };

                    // تعطيل الأزرار حسب الحالة
                    if (order.can_edit === false) {
                        obj.watting = <span className="status-badge status-disabled">مرسل</span>;
                        obj.delete = <span className="status-badge status-disabled">مرسل</span>;
                        obj.edit_order = <span className="status-badge status-disabled">مرسل</span>;
                    }
                    if (order.status === 2) {
                        obj.watting = <span className="status-badge status-cancelled">ملغي</span>;
                        obj.delete = <span className="status-badge status-cancelled">ملغي</span>;
                        obj.edit_order = <span className="status-badge status-cancelled">ملغي</span>;
                        obj.edit = <span className="status-badge status-cancelled">ملغي</span>;
                    }

                    return obj;
                });

                this.setState({ Category: arr, ordersRaw: res.data.data.orders, spin: false });
            })
            .catch(error => {
                console.log(error);
                this.setState({ spin: false });
                toast.error('حدث خطأ في التحميل');
            });
    };

    DeleteCate = (id) => {
        this.showLoading('حذف الطلب', 'جاري الحذف...');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        axios.delete(host + `users/all/ordrers/${id}`, { headers: header })
            .then(() => {
                this.hideLoading();
                toast.success('تم الحذف');
                this.Search(id);
            })
            .catch(() => {
                this.hideLoading();
                toast.error('حدث خطأ');
            });
    };

    EditItem = (id) => {
        if (!this.state.priceItem) {
            toast.warn('أدخل السعر');
            return;
        }

        this.showLoading('تعديل السعر', 'جاري الحفظ...');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        const formData = new FormData();
        formData.append("price", this.state.priceItem);

        axios({ url: host + `dashbord/form/orders/edit/${id}`, method: "PUT", data: formData, headers: header })
            .then(() => {
                this.hideLoading();
                this.Search();
                toast.success('تم التعديل');
            })
            .catch(() => {
                this.hideLoading();
                toast.error('حدث خطأ');
            });
    };

    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => (
                        <div className="app-container">
                            <style>{appStyles}</style>

                            {/* Loading Overlay */}
                            <div className={`loading-overlay ${this.state.loadingAction ? 'active' : ''}`}>
                                <div className="loading-spinner"></div>
                                <p className="loading-text">{this.state.loadingMessage}</p>
                                <p className="loading-subtext">{this.state.loadingSubtext}</p>
                            </div>

                            {/* Header */}
                            <header className="app-header">
                                <div className="header-right">
                                    <button className="btn-back-header" onClick={() => window.history.back()}>→</button>
                                    <h1 className="header-title">إدارة الطلبات</h1>
                                </div>
                                <div className="header-stats">
                                    {this.state.Category.length > 0 && (
                                        <span className="stat-chip">{this.state.Category.length} طلب</span>
                                    )}
                                </div>
                            </header>

                            {/* Search */}
                            <section className="search-section">
                                <div className="search-wrapper">
                                    <div className="search-input-container">
                                        <input
                                            type="text"
                                            className="search-input"
                                            placeholder="بحث برقم الطلب أو القائمة..."
                                            id="searchINN"
                                            onKeyPress={(e) => e.key === "Enter" && this.Search(e.target.value.trim() || 'ss')}
                                        />
                                        <button className="search-btn" onClick={() => this.Search(document.getElementById('searchINN').value.trim() || 'ss')}>
                                            بحث
                                        </button>
                                    </div>
                                </div>
                            </section>

                            {/* Main Content */}
                            <main className="main-content">
                                {/* Loading State */}
                                {this.state.spin && (
                                    <div className="empty-state">
                                        <div className="loading-spinner" style={{ margin: '0 auto' }}></div>
                                        <p className="empty-state-title" style={{ marginTop: 20 }}>جاري التحميل...</p>
                                    </div>
                                )}

                                {/* Empty State */}
                                {!this.state.spin && this.state.Category.length === 0 && (
                                    <div className="empty-state">
                                        <div className="empty-state-icon">📭</div>
                                        <h3 className="empty-state-title">لا توجد طلبات</h3>
                                        <p className="empty-state-text">ابحث عن طلب للبدء</p>
                                        <button className="btn-primary-custom" onClick={() => this.Search('ss')}>تحميل الطلبات</button>
                                    </div>
                                )}

                                {/* Desktop Table */}
                                {!this.state.spin && this.state.Category.length > 0 && (
                                    <div className="table-card desktop-table">
                                        <div className="table-card-header">
                                            <h2 className="table-card-title">قائمة الطلبات</h2>
                                            <span className="table-card-count">{this.state.Category.length}</span>
                                        </div>
                                        <MuiThemeProvider theme={this.getMuiTheme()}>
                                            <MaterialDatatable data={this.state.Category} columns={columns} options={options} />
                                        </MuiThemeProvider>
                                    </div>
                                )}

                                {/* Mobile Cards */}
                                {!this.state.spin && this.state.Category.length > 0 && (
                                    <div className="mobile-cards-container">
                                        <div className="table-card-header" style={{ background: '#fff', borderRadius: 12, marginBottom: 15 }}>
                                            <h2 className="table-card-title">قائمة الطلبات</h2>
                                            <span className="table-card-count">{this.state.Category.length}</span>
                                        </div>
                                        {this.state.ordersRaw?.map((order, index) => (
                                            <div className="order-card" key={index}>
                                                <div className="order-card-header">
                                                    <span className="order-card-id">#{order.id}</span>
                                                    {this.getStatusBadge(order.status)}
                                                </div>
                                                <div className="order-card-body">
                                                    <div className="order-card-row">
                                                        <span className="order-card-label">المستخدم</span>
                                                        <span className="order-card-value">{order.user?.name}</span>
                                                    </div>
                                                    <div className="order-card-row">
                                                        <span className="order-card-label">الهاتف</span>
                                                        <span className="order-card-value">{order.phone}</span>
                                                    </div>
                                                    <div className="order-card-row">
                                                        <span className="order-card-label">الموقع</span>
                                                        <span className="order-card-value">{order.government} / {order.city}</span>
                                                    </div>
                                                    <div className="order-card-row">
                                                        <span className="order-card-label">السعر</span>
                                                        <span className="order-card-value" style={{ color: '#31a24c', fontWeight: 700 }}>{order.price?.toLocaleString()} د.ع</span>
                                                    </div>
                                                    <div className="order-card-row">
                                                        <span className="order-card-label">التاريخ</span>
                                                        <span className="order-card-value">{moment(order.createdAt).tz('Asia/baghdad').format('YYYY/MM/DD')}</span>
                                                    </div>
                                                </div>
                                                <div className="order-card-actions">
                                                    {order.status !== 2 && order.can_edit !== false && (
                                                        <>
                                                            {/* زر تعديل الطلب */}
                                                            <Component initialState={{ isShown: false, selectedItems: [] }}>
                                                                {({ state, setState }) => (
                                                                    <React.Fragment>
                                                                        <SideSheet isShown={state.isShown} position="left" onCloseComplete={() => setState({ isShown: false })} width={typeof window !== 'undefined' && window.innerWidth < 500 ? '100%' : 420}>
                                                                            <div className="sidesheet-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                <h3 className="sidesheet-title">تعديل الطلب #{order.id}</h3>
                                                                                <button 
                                                                                    onClick={() => setState({ isShown: false })}
                                                                                    style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: 36, height: 36, color: '#fff', fontSize: 20, cursor: 'pointer' }}
                                                                                >
                                                                                    ✕
                                                                                </button>
                                                                            </div>
                                                                            <div className="sidesheet-body">
                                                                                <div className="sidesheet-card">
                                                                                    <div className="sidesheet-card-title">اختر المنتجات</div>
                                                                                    <MultiSelect
                                                                                        items={this.state.items}
                                                                                        selectedItems={state.selectedItems}
                                                                                        onChange={(e) => setState({ selectedItems: e })}
                                                                                        showSelectedItems={false}
                                                                                        showSelectAll={false}
                                                                                    />
                                                                                    {state.selectedItems.length > 0 && (
                                                                                        <table className="custom-table" style={{ marginTop: 15 }}>
                                                                                            <thead><tr><th>العدد</th><th>المنتج</th></tr></thead>
                                                                                            <tbody>
                                                                                                {state.selectedItems.map((item, i) => (
                                                                                                    <tr key={i}>
                                                                                                        <td><input type="number" className="form-input-custom" id={`mobile_${item.id}_${order.id}`} defaultValue={1} min="1" style={{ width: 70 }} /></td>
                                                                                                        <td>{item.label}</td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    )}
                                                                                </div>
                                                                                <div className="form-group-custom">
                                                                                    <label className="form-label-custom">السعر مع التوصيل</label>
                                                                                    <input type="number" className="form-input-custom" id={`Editprice_mobile_${order.id}`} placeholder="السعر" />
                                                                                </div>
                                                                                <div className="form-group-custom">
                                                                                    <label className="form-label-custom">ملاحظات</label>
                                                                                    <textarea className="form-input-custom" id={`Editnotes_mobile_${order.id}`} placeholder="ملاحظات..." rows={3} style={{ resize: 'none' }} />
                                                                                </div>
                                                                                <button
                                                                                    className="btn-primary-custom"
                                                                                    style={{ width: '100%' }}
                                                                                    onClick={() => {
                                                                                        const price = document.getElementById(`Editprice_mobile_${order.id}`)?.value;
                                                                                        const notes = document.getElementById(`Editnotes_mobile_${order.id}`)?.value;
                                                                                        if (!price) { toast.warn('أدخل السعر'); return; }
                                                                                        const arr = state.selectedItems.map(item => ({
                                                                                            id: item.id,
                                                                                            name: item.label,
                                                                                            count: Number(document.getElementById(`mobile_${item.id}_${order.id}`)?.value || 1)
                                                                                        }));
                                                                                        this.showLoading('تعديل الطلب', 'جاري الحفظ...');
                                                                                        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
                                                                                        const formData = new FormData();
                                                                                        formData.append("price", price);
                                                                                        formData.append("notes", notes);
                                                                                        formData.append("items", JSON.stringify(arr));
                                                                                        axios({ url: host + `dashbord/order/edit/${order.id}`, method: "POST", data: formData, headers: header })
                                                                                            .then(() => { this.hideLoading(); this.Search(); toast.success('تم التعديل'); setState({ isShown: false }); })
                                                                                            .catch(() => { this.hideLoading(); toast.error('حدث خطأ'); });
                                                                                    }}
                                                                                >
                                                                                    حفظ التعديلات
                                                                                </button>
                                                                                <button
                                                                                    className="btn-secondary-custom"
                                                                                    style={{ width: '100%', marginTop: 10 }}
                                                                                    onClick={() => setState({ isShown: false })}
                                                                                >
                                                                                    إلغاء
                                                                                </button>
                                                                            </div>
                                                                        </SideSheet>
                                                                        <button className="action-btn blue" onClick={() => setState({ isShown: true })} title="تعديل الطلب">
                                                                            <Edit style={{ fontSize: 18 }} />
                                                                        </button>
                                                                    </React.Fragment>
                                                                )}
                                                            </Component>

                                                            {/* زر تعديل السعر */}
                                                            <Component initialState={{ isShown: false, newPrice: '' }}>
                                                                {({ state, setState }) => (
                                                                    <Pane>
                                                                        <Dialog
                                                                            isShown={state.isShown}
                                                                            title="تعديل السعر"
                                                                            onCloseComplete={() => setState({ isShown: false })}
                                                                            confirmLabel="تعديل"
                                                                            cancelLabel="إلغاء"
                                                                            onConfirm={() => {
                                                                                if (!state.newPrice) { toast.warn('أدخل السعر'); return; }
                                                                                this.showLoading('تعديل السعر', 'جاري الحفظ...');
                                                                                const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
                                                                                const formData = new FormData();
                                                                                formData.append("price", state.newPrice);
                                                                                axios({ url: host + `dashbord/form/orders/edit/${order.id}`, method: "PUT", data: formData, headers: header })
                                                                                    .then(() => { this.hideLoading(); this.Search(); toast.success('تم التعديل'); setState({ isShown: false }); })
                                                                                    .catch(() => { this.hideLoading(); toast.error('حدث خطأ'); });
                                                                            }}
                                                                        >
                                                                            <div style={{ padding: 15, direction: 'rtl' }}>
                                                                                <div className="form-group-custom">
                                                                                    <label className="form-label-custom">السعر الجديد</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-input-custom"
                                                                                        placeholder="أدخل السعر"
                                                                                        value={state.newPrice}
                                                                                        onChange={(e) => setState({ newPrice: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </Dialog>
                                                                        <button className="action-btn orange" onClick={() => setState({ isShown: true })} title="تعديل السعر">
                                                                            <MoneyOff style={{ fontSize: 18 }} />
                                                                        </button>
                                                                    </Pane>
                                                                )}
                                                            </Component>

                                                            {/* زر إعادة */}
                                                            <Component initialState={{ isShown: false }}>
                                                                {({ state, setState }) => (
                                                                    <Pane>
                                                                        <Dialog
                                                                            isShown={state.isShown}
                                                                            title="إلغاء وإعادة"
                                                                            intent="success"
                                                                            onCloseComplete={() => setState({ isShown: false })}
                                                                            confirmLabel="تأكيد"
                                                                            cancelLabel="إلغاء"
                                                                            onConfirm={() => { setState({ isShown: false }); this.restore(order.id); }}
                                                                        >
                                                                            <div className="dialog-content">
                                                                                <div className="dialog-icon">🔄</div>
                                                                                <p className="dialog-message">إلغاء وإعادة الطلب #{order.id}؟</p>
                                                                            </div>
                                                                        </Dialog>
                                                                        <button className="action-btn green" onClick={() => setState({ isShown: true })} title="إلغاء وإعادة">
                                                                            <Autorenew style={{ fontSize: 18 }} />
                                                                        </button>
                                                                    </Pane>
                                                                )}
                                                            </Component>

                                                            {/* زر حذف */}
                                                            <Component initialState={{ isShown: false }}>
                                                                {({ state, setState }) => (
                                                                    <Pane>
                                                                        <Dialog
                                                                            isShown={state.isShown}
                                                                            title="حذف الطلب"
                                                                            intent="danger"
                                                                            onCloseComplete={() => setState({ isShown: false })}
                                                                            confirmLabel="حذف"
                                                                            cancelLabel="إلغاء"
                                                                            onConfirm={() => { setState({ isShown: false }); this.DeleteCate(order.id); }}
                                                                        >
                                                                            <div className="dialog-content">
                                                                                <div className="dialog-icon">⚠️</div>
                                                                                <p className="dialog-message">حذف الطلب #{order.id}؟</p>
                                                                                <p className="dialog-submessage">لا يمكن التراجع عن هذا الإجراء</p>
                                                                            </div>
                                                                        </Dialog>
                                                                        <button className="action-btn red" onClick={() => setState({ isShown: true })} title="حذف">
                                                                            <DeleteForeverIcon style={{ fontSize: 18 }} />
                                                                        </button>
                                                                    </Pane>
                                                                )}
                                                            </Component>
                                                        </>
                                                    )}
                                                    {(order.status === 2 || order.can_edit === false) && (
                                                        <span className="status-badge status-disabled">
                                                            {order.status === 2 ? 'ملغي' : 'مرسل'}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </main>

                            <ToastContainer position="bottom-center" autoClose={3000} rtl={true} theme="light" />
                        </div>
                    )}
                </Context.Consumer>
            );
        } else {
            return (
                <div className="login-page">
                    <style>{appStyles}</style>
                    <div className="login-card">
                        <div className="login-icon">🔐</div>
                        <h3 className="login-title">تسجيل الدخول</h3>
                        <Login />
                    </div>
                </div>
            );
        }
    }
}

export default fromOrders;
